<template>
    <div class="club-item">
        <div v-if="!editMode">
            <span class="club">
                {{ venue.name }}<br />
                {{ venue.address }}<br />
                {{ venue.telephone }}<br />
                {{ venue.website }}
            </span>
            <button
                @click.prevent="editMode = true"
                class="button half dark"
                type="button"
                name="button"
            >
                Edit
            </button>
            <button @click.prevent="deleteClub" class="button half red" type="button" name="button">
                Delete
            </button>
        </div>

        <form class="form" v-else @submit.prevent="updateClub">
            <div class="formGroup">
                <label>Name</label>
                <input autocomplete="nope" maxlength="255" type="text" v-model="form.name" />
                <has-error :form="form" field="name" />
            </div>
            <div class="formGroup">
                <label>Address</label>
                <textarea-autosize v-model="form.address" :min-height="30" />
            </div>

            <div class="formGroup">
                <label>Phone</label>
                <input autocomplete="nope" maxlength="255" type="tel" v-model="form.telephone" />
            </div>

            <div class="formGroup">
                <label>Website</label>
                <input autocomplete="nope" maxlength="255" type="text" v-model="form.website" />
            </div>

            <div class="formGroup">
                <button class="button half" type="submit" name="button">
                    {{ form.busy ? "Please wait..." : "Save" }}
                </button>

                <button
                    @click.prevent="cancelEdit"
                    class="button half red"
                    type="submit"
                    name="button"
                >
                    Cancel
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import { Form, HasError } from "vform";
export default {
    name: "",
    props: ["venue"],
    components: { HasError },
    data() {
        return {
            editMode: false,
            form: new Form({
                id: "",
                name: "",
                address: "",
                telephone: "",
                website: "",
            }),
        };
    },
    mounted() {
        console.log(this.venue);
        if (!this.venue.id) {
            this.editMode = true;
        } else {
            this.form.fill(this.venue);
        }
    },
    methods: {
        cancelEdit() {
            this.editMode = false;
            this.$emit("openCreate", this.venue);
        },
        deleteClub() {
            this.$confirm("Are you sure you want to delete this club?", () => {
                this.form.delete("/club/" + this.venue.id).then(() => {
                    this.$emit("clubDeleted", this.venue);
                    this.$notify("Club deleted");
                });
            });
        },
        updateClub() {
            if (this.venue.id) {
                this.form.put("/club/" + this.venue.id).then((response) => {
                    this.cancelEdit();
                    this.$notify({
                        text: "Venue details updated",
                    });
                    this.$emit("clubUpdated", response.data);
                });
            } else {
                this.form.post("/club").then((response) => {
                    this.cancelEdit();
                    this.$notify({
                        text: "Venue details created",
                    });
                    this.$emit("clubAdded", response.data);
                });
            }
        },
    },
};
</script>

<style lang="less" scoped>
.club {
    color: white;
    line-height: 1.5;
    margin-bottom: 20px;
    display: block;
}
.club-item {
    margin-bottom: 20px;
}
.form {
    padding-top: 0px !important;
    padding-left: 0px !important;
    padding-right: 0px !important;
}
</style>
